import instance from '@apis/instance';
import { IdentifyRequest, IdentifyResponse } from '@models/identify';

class IdentifyApi {
    static identify(request: IdentifyRequest): Promise<IdentifyResponse> {
        return instance.post('/v0/identity/verification/nice', request);
    }

    static identifyForEasyCardPin(projectId: string): Promise<IdentifyResponse> {
        return instance.post('/v0/identity/verification/nice/easy-card-pin', { projectId });
    }
}

export default IdentifyApi;
